import React, { useMemo } from "react";

import { StepsContainer } from "../../styles/commonStyles";
import StatusBanner from "../../UI/StatusBanner";
import PendingNote from "../../UI/PendingNote";
import styled from "styled-components";
import {
  getRejectedStep,
  isActionDoneOnAllStepsOrRejectedAtleastOne,
  isAllApproved,
} from "../../utils/helper";
import { PHOTO_VERIFICATION_STEPS } from "./config/photoVerificationSteps";
import { isEmpty } from "../../utils";
import { getTabsConfig } from "../../../../views/QcDetails/configs/tabs.config";

const PhotoVerification = ({
  qcDetails,
  setCurrentTab,
  documentDetailsSteps,
  photoVerificationSteps,
  ...props
}) => {
  const isTerminated = qcDetails?.driver_lifecycle_status === "terminated";

  const isAllStepsApproved = isAllApproved(qcDetails, photoVerificationSteps);
  const rejectedStep = getRejectedStep(qcDetails, photoVerificationSteps);
  const isPhotoReviewed = isAllApproved(
    qcDetails,
    photoVerificationSteps,
    "basic_details"
  );
  const isDocumentReviewed = isActionDoneOnAllStepsOrRejectedAtleastOne(
    qcDetails,
    documentDetailsSteps,
    "document_details"
  );
  const tabs = getTabsConfig();

  return (
    <StepsContainer>
      {isAllStepsApproved &&
      !isTerminated &&
      photoVerificationSteps?.length > 0 ? (
        <StatusBanner type="success" title="Photo verification completed" />
      ) : !isTerminated &&
        !isEmpty(rejectedStep) &&
        photoVerificationSteps?.length > 0 ? (
        <StatusBanner
          type="error"
          title="Photo verification failed"
          // message={rejectedStep?.rejection_reason}
        />
      ) : (
        photoVerificationSteps?.length === 0 && (
          <StatusBanner
            type="warning"
            title="The Delivery partner has not yet filled all the details."
          />
        )
      )}

      {photoVerificationSteps.map((step, index) => {
        const StepComponent = PHOTO_VERIFICATION_STEPS.find(
          (item) => item.key === step.key
        )?.component;

        return (
          <StepComponent
            key={index}
            stepNum={index + 1}
            {...props}
            photoVerificationSteps={photoVerificationSteps}
          />
        );
      })}

      {!isDocumentReviewed && isPhotoReviewed && (
        <PendingNoteContainer>
          <PendingNote
            message="Complete your document verification"
            buttonText="Complete now"
            onBtnClick={() => setCurrentTab(tabs[1])}
            btnStyle={{
              width: "145px",
              padding: "0",
              height: "38px",
            }}
          />
        </PendingNoteContainer>
      )}
    </StepsContainer>
  );
};

export default PhotoVerification;

export const PendingNoteContainer = styled.div`
  margin-top: auto;
`;
